
import React from 'react'
import './TitleCard.css'



interface CardProps {
    title: string;
    body: string;
}

export const TitleCard: React.FC<CardProps> = ({title,body}) => {
        return (
                <div className="paragraph card">
                    <div className="card-header">
                        <h5>{title}</h5>
                    </div>
                    <div className="card-body">
                        <h5>{body}</h5>
                    </div>
                </div>
        )
}